import { useEffect, useRef, useCallback } from 'react';
import * as Cesium from 'cesium';
export const useProfileCrosshair = ({ viewer }) => {
    const dataSourceRef = useRef(null);
    const entityRef = useRef(null);
    useEffect(() => {
        if (!viewer)
            return;
        const ds = new Cesium.CustomDataSource('profile-crosshair');
        viewer.dataSources.add(ds);
        dataSourceRef.current = ds;
        return () => {
            if (viewer && !viewer.isDestroyed()) {
                viewer.dataSources.remove(ds, true);
            }
            dataSourceRef.current = null;
            entityRef.current = null;
        };
    }, [viewer]);
    const showCrosshair = useCallback((position, color) => {
        const ds = dataSourceRef.current;
        if (!ds)
            return;
        const cesiumColor = Cesium.Color.fromCssColorString(color);
        if (entityRef.current) {
            entityRef.current.position = new Cesium.ConstantPositionProperty(position);
            const point = entityRef.current.point;
            if (point) {
                point.color = new Cesium.ConstantProperty(cesiumColor);
                point.outlineColor = new Cesium.ConstantProperty(Cesium.Color.WHITE);
            }
        }
        else {
            entityRef.current = ds.entities.add({
                position,
                point: {
                    pixelSize: 12,
                    color: cesiumColor,
                    outlineColor: Cesium.Color.WHITE,
                    outlineWidth: 2,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    disableDepthTestDistance: Number.POSITIVE_INFINITY
                }
            });
        }
    }, []);
    const hideCrosshair = useCallback(() => {
        const ds = dataSourceRef.current;
        if (!ds)
            return;
        if (entityRef.current) {
            ds.entities.remove(entityRef.current);
            entityRef.current = null;
        }
    }, []);
    return { showCrosshair, hideCrosshair };
};
